import {createSlice, type PayloadAction} from '@reduxjs/toolkit';

import type {Calibration, MappedInference} from '@/types/inference';

interface CalibrationProgress {
    n_sticks_identified: number;
    min_n_experiences_required: number;
}

interface InferenceState {
    inferenceData: MappedInference | null;
    isLoading: boolean;
}

const initialState: InferenceState = {
    inferenceData: null,
    isLoading: false,
};

const inferenceSlice = createSlice({
    name: 'inference',
    initialState,
    reducers: {
        setInferenceData(state, action: PayloadAction<MappedInference>) {
            state.inferenceData = action.payload;
        },
        setInferenceLoading(state, action: PayloadAction<boolean>) {
            state.isLoading = action.payload;
        },
        setCalibrationProgress(state, action: PayloadAction<CalibrationProgress>) {
            const calibration = {...state.inferenceData?.calibration, ...action.payload} as Calibration;

            state.inferenceData = {
                inferenceTimestamp: state.inferenceData?.inferenceTimestamp ?? '',
                experienceScore: null,
                tipsToConsider: null,
                insightsAndTips: null,
                ...state.inferenceData,
                calibration,
            };
        },
        clearInferenceData(state) {
            state.inferenceData = null;
        },
    },
});

export const {setInferenceData, setInferenceLoading, setCalibrationProgress, clearInferenceData} =
    inferenceSlice.actions;

export default inferenceSlice.reducer;
